import { gql } from "@apollo/client";

const createCustomsShipmentPalletMutation = gql`
  mutation ($customsShipmentId: ID!, $shippingCarrierId: ID) {
    createCustomsShipmentPallet(
      customsShipmentId: $customsShipmentId
      shippingCarrierId: $shippingCarrierId
    ) {
      createdCustomsShipmentPallet {
        id
        shipment {
          id
          pallets {
            id
          }
        }
      }
      errors {
        customsShipmentId
        shippingCarrierId
      }
      succeeded
    }
  }
`;

export default createCustomsShipmentPalletMutation;
